import React, { FC } from "react";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { useModal } from "src/hooks/useModal";
import { COOKIE_OPEN } from "src/constants/cookiesKeys";
import { PATHNAMES } from "src/constants/routes";
import { cookiePopupTrns } from "./trns";
import { Link } from "../Link";
import { Button } from "../Button";
import { ModalWindowV2 } from "../ModalWindowV2";
import { ButtonVariants } from "../Button/types";
import { ModalMode } from "../ModalWindowV2/types";

const TRUE = "true" as const;

interface Props extends ReturnType<typeof useModal> {}

export const CookiePopup: FC<Props> = ({ ...modalProps }) => {
  const { t } = useTranslation();

  const onUnderstandClick = () => {
    modalProps.closeModal();
    Cookies.set(COOKIE_OPEN, TRUE);
  };

  return (
    <ModalWindowV2
      {...modalProps}
      className="px-5 md:px-0"
      mode={ModalMode.notice}
      isActiveCloseClickOutside={false}
      isShownOverlay={false}
    >
      <div className="flex flex-col gap-4 p-5 max-w-162.5 bg-white-base border border-black-base/20 rounded-20 ">
        <h3 className="text-2xl text-black-base font-steppe font-semibold">
          {t(cookiePopupTrns.title)}
        </h3>

        <p className="text-justify">{t(cookiePopupTrns.description)}</p>

        <div className="flex gap-4 items-center flex-1 font-medium md:text-20">
          <Link href={PATHNAMES.COOKIE_POCILY} className="flex-1">
            <Button
              variant={ButtonVariants.SECONDARY}
              className="w-full !border-blue-dark py-1"
              onClick={modalProps.closeModal}
            >
              {t(cookiePopupTrns.readMoreButton)}
            </Button>
          </Link>

          <Button
            variant={ButtonVariants.PRIMARY}
            className="flex-1 py-1"
            onClick={onUnderstandClick}
          >
            {t(cookiePopupTrns.understandButton)}
          </Button>
        </div>
      </div>
    </ModalWindowV2>
  );
};
